import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

const PromocodeSelectors = createBasicSelectors('promocode')

export default PromocodeSelectors
